import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { pick } from "../managementDashboardUtils";
import { EXECUTIVE_OVERVIEW_KPI_SPECS } from "../managementDashboardConstants";

const findKpi = (kpis, codes = []) => {
  if (!Array.isArray(kpis)) return null;
  for (const code of codes) {
    const match = kpis.find((k) => pick(k, "code", "Code") === code);
    if (match) return match;
  }
  return null;
};

const formatPercent = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return `${formatNumber(Number(value), 2)}٪`;
};

/**
 * Builds 8 executive header cards from existing GetExecutiveKpis + GetAnalytics payloads.
 */
export const buildExecutiveOverviewKpis = ({
  executiveKpis = [],
  overview = null,
  growthAnalytics = null,
  funnelMeta = null,
}) => {
  const growthSummary =
    growthAnalytics?.summary || growthAnalytics?.Summary || null;

  return EXECUTIVE_OVERVIEW_KPI_SPECS.map((spec) => {
    const backendKpi = findKpi(executiveKpis, spec.kpiCodes);

    if (backendKpi) {
      return {
        slot: spec.slot,
        title: spec.title,
        description: spec.description,
        kpi: backendKpi,
        source: "GetExecutiveKpis",
      };
    }

    if (spec.overviewKey && overview) {
      const raw = pick(
        overview,
        spec.overviewKey,
        spec.overviewKey.charAt(0).toUpperCase() + spec.overviewKey.slice(1)
      );
      return {
        slot: spec.slot,
        title: spec.title,
        description: spec.description,
        kpi: {
          title: spec.title,
          value: raw,
          unit: spec.slot === "installedPlants" ? "پروژه" : "",
          isAvailable: raw != null,
          metricType: 2,
          comparisonState: 3,
        },
        source: "GetAnalytics.Overview",
      };
    }

    if (spec.growthKey && growthSummary) {
      const rate =
        growthSummary[spec.growthKey]
        ?? growthSummary.AverageConversionRate
        ?? growthSummary.averageConversionRate;
      return {
        slot: spec.slot,
        title: spec.title,
        description: spec.description,
        kpi: {
          title: spec.title,
          value: rate,
          unit: "%",
          isAvailable: rate != null,
          metricType: 1,
          comparisonState: 3,
          formattedValue: formatPercent(rate),
        },
        source: "GetAnalytics.GrowthAnalytics",
      };
    }

    if (spec.slot === "totalRequests" && funnelMeta?.cohortSize != null) {
      return {
        slot: spec.slot,
        title: spec.title,
        description: spec.description,
        kpi: {
          title: spec.title,
          value: funnelMeta.cohortSize,
          unit: "درخواست",
          isAvailable: true,
          metricType: 1,
          comparisonState: 3,
        },
        source: "GetFunnel",
      };
    }

    return {
      slot: spec.slot,
      title: spec.title,
      description: spec.description,
      kpi: {
        title: spec.title,
        isAvailable: false,
        unavailableReason: "داده این شاخص در API فعلی موجود نیست.",
      },
      source: "missing",
    };
  });
};
